<template>
  <div class="edit-video-box">
    <el-dialog
      :title="''"
      :visible.sync="dialogVisible"
      width="640px"
      top="50px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules">
        <div class="flex just-center flex-c align-item-center">
          <div class="form_item flex-c ">
            <h1 class="mb-10 flex just-center">
              当前用户身份是：<span v-if="editParam.vipLevel == 0"
                >普通用户</span
              >
              <span v-if="editParam.vipLevel == 1">VIP</span>
              <span v-if="editParam.vipLevel == 2">SVIP(超级VIP)</span>
              <span v-if="expireFlag" class="red ml-5">已过期</span>
              <span v-else class="green ml-5">生效中</span>
            </h1>
            <el-form-item label="VIP商品会员卡:" prop="vipProductLevel">
              <el-select
                v-model="editParam.vipProductLevel"
                size="small"
                placeholder="请选择会员卡"
                @change="handleChangeVip"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in vipProductLevelList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="VIP等级:" prop="vipLevel">
              <el-select v-model="editParam.vipLevel" size="small">
                <el-option
                  v-for="item in vipLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="VIP到期时间:" prop="vipExpireDate">
              <el-date-picker
                type="datetime"
                v-model="editParam.vipExpireDate"
                placeholder="选择日期时间"
                size="small"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="['']" prop="goldVideoFreeLimit">
             <div class="fw">1：{{editParam.goldVideoFreeLimit}}以下金币视频可看 --(等于0代表不可看)</div>
             <div class="fw">2：发送私信需要({{chatPrice}})金币 -- (大于0代表需要扣金币)</div>
            <div class="fw">
              <span v-if="editParam.vipLevel == 2">3：有暗网权限</span>
              <span v-else>3：无暗网权限</span>
            </div>
            </el-form-item>
          </div>
          <div class="dialog-footer">
            <el-button @click="handleClose" size="small">取 消</el-button>
            <el-button
              type="primary"
              @click="handleUpdateVip"
              :loading="flag"
              size="small"
              >确 认
            </el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import {changeDate} from "@/utils/global";

export default {
  data() {
    return {
      flag: false,
      dialogVisible: false,
      editParam: {
        uid: "",
        vipProductLevel: "",
        vipProductName: "",
        vipLevel: "",
        vipExpireDate: "",
      },
      chatPrice:100,
      globalLimit:0,
      vipProductLevelList: [],
      vipProductLevelListAll: [],
      vipLevelList: [
        { value: 0, label: "非VIP" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
      ],
      rules: {
        vipExpireDate: [
          { required: true, message: "请选择VIP到期时间", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getVipProductLevelList();
  },
  computed: {
    expireFlag() {
      var time =
        new Date().getTime() - new Date(this.editParam.vipExpireDate).getTime();
      return time > 0;
    },
  },
  methods: {
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    handleChangeVip(e) {
      if(e != '-1' && e != '-2' && e != '-3' && e != '-4') {
        var productName = this.vipProductLevelListAll.find(
            (c) => c.id == e
        ).productName;
        let vipLevel = this.vipProductLevelListAll.find(
            (c) => c.id == e
        ).vipLevel;
        var duration = this.vipProductLevelListAll.find(
            (c) => c.id == e
        ).duration;
        var goldVideoFreeLimit = this.vipProductLevelListAll.find(
            (c) => c.id == e
        ).goldVideoFreeLimit;

        var chatPrice = this.vipProductLevelListAll.find(
            (c) => c.id == e
        ).chatPrice;
        this.chatPrice = chatPrice;
        this.editParam.vipProductName = productName;
        this.editParam.vipProductLevel = e;
        this.editParam.vipLevel = vipLevel;
        this.editParam.goldVideoFreeLimit = goldVideoFreeLimit
        this.editParam.vipExpireDate = this.addDays(new Date(), duration);
      }else{
        let vipLevel = 0
        let vipDays = -1
        if(e !== '-3') {
          vipLevel = 1
          vipDays = 1
        }
        this.editParam.vipProductName = productName;
        this.editParam.vipProductLevel = e;
        this.editParam.vipLevel = vipLevel;
        this.editParam.goldVideoFreeLimit = 0
        this.editParam.vipExpireDate = this.addDays(new Date(), vipDays);
        this.chatPrice = 100;
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
    },
    getVipProductLevelList() {
      this.vipProductLevelList = [];
      API.getPruductList().then((res) => {
        if (res.code === 200) {
          this.vipProductLevelListAll = res.data;
          this.vipProductLevelList = res.data.map((item) => ({
            value: item.id,
            label: item.productName,
          }));
          this.vipProductLevelList.push({
            value: "-1",
            label: "积分兑换VIP",
          });
          this.vipProductLevelList.push({
            value: "-2",
            label: "签到领取VIP",
          });
          this.vipProductLevelList.push({
            value: "-4",
            label: "邀请VIP会员",
          });
          this.vipProductLevelList.push({
            value: "-3",
            label: "卸载VIP身份",
          });
        }
      });
    },

    // 修改VIP身份
    handleUpdateVip() {
      var expireTime = changeDate(this.editParam.vipExpireDate)
      let params = {
        uid: this.editParam.uid,
        vipProductLevel: this.editParam.vipProductLevel,
        vipProductName: this.editParam.vipProductName,
        vipExpireDate: expireTime,
        vipLevel: this.editParam.vipLevel,
      };
      API.editUserVip(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.$emit("goBack");
            this.handleClose();
          } else {
            this.$message.error("操作失败!");
          }
        })
        .catch(() => {});
    },

    async open(row) {
      await this.getVipProductLevelList();
      window.console.log("row",row)
      this.editParam.uid = row.uid;
      this.editParam.vipLevel = row.vipLevel;
      this.editParam.vipExpireDate = row.vipExpireDate;
      this.editParam.vipProductLevel = row.vipProductLevel ;
      this.editParam.vipProductName = row.vipProductName ;
      this.editParam.goldVideoFreeLimit = row.goldVideoFreeLimit ;
      this.dialogVisible = true;
      this.chatPrice = row.chatPrice
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
  .el-form-item {
    margin-bottom:8px !important;
  }
}

.form_item {
  display: flex;
}

.item .el-form-item__label {
  line-height: 20px !important;
}


</style>
